export const getPreviewUrl = (bizId, theme = "") => {
	const themeName = theme + "." ?? "";
	const isProdEnd = process.env.REACT_APP_MERAKI_API_URL === "https://editor-api.meraki.zone/api/v1";

	const previewLink = `https://${bizId}.${themeName}preview${!isProdEnd ? "-beta" : ""}.meraki.zone`;

	return previewLink;
};
